import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DIAGNOSTICS_SUBTABS } from './adminSections';
import AdminLogs from './AdminLogs';
import AdminMcp from './AdminMcp';

const SUBTAB_COMPONENTS = {
  logs: AdminLogs,
  mcp: AdminMcp,
};

/**
 * Diagnostik — merged container for the monitoring screens that each used to be
 * their own sidebar tab (Loggar, MCP). Both are owner-only. The active sub-tab
 * is driven by the `?sub=` query param so legacy `/webadmin/logs` and
 * `/webadmin/mcp` URLs redirect here cleanly.
 */
export default function AdminDiagnostics({ perms }) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const visibleTabs = DIAGNOSTICS_SUBTABS.filter((tab) => tab.check(perms));

  const requested = searchParams.get('sub');
  const activeKey = visibleTabs.some((tab) => tab.key === requested)
    ? requested
    : (visibleTabs[0]?.key || null);

  const setActive = (key) => setSearchParams({ sub: key }, { replace: true });

  const ActiveComponent = activeKey ? SUBTAB_COMPONENTS[activeKey] : null;

  return (
    <div>
      <h1 className="admin-section-title">{t('admin.navDiagnostics')}</h1>

      <div className="admin-tabs">
        {visibleTabs.map((tab) => (
          <button
            key={tab.key}
            className={`admin-tab ${activeKey === tab.key ? 'active' : ''}`}
            onClick={() => setActive(tab.key)}
          >
            {t(tab.labelKey)}
          </button>
        ))}
      </div>

      {ActiveComponent ? (
        <ActiveComponent hideTitle />
      ) : (
        <div className="admin-info">{t('admin.noAccessSection')}</div>
      )}
    </div>
  );
}
